import React from 'react';

const SquareInfotag = () => {
  return <div></div>;
};

export default SquareInfotag;
